var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{ref:"mui-content-editable-list",tag:"component",staticClass:"mui-editable-list",attrs:{"contenteditable":"true","data-placeholder":_vm.placeholder},on:{"blur":_vm.handleBlur,"click":_vm.handleClick,"input":_vm.handleInput,"keydown":_vm.handleKeyDown,"paste":_vm.handlePaste}},_vm._l((_vm.items),function(item){return _c('li',{key:item.key,class:{
      'mui-editable-list-item': true,
      'mui-list-section': _vm.listItemIsSection(item.text)
    },attrs:{"data-list-item-key":item.key}},[_vm._v(_vm._s(item.text))])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc364320","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MUIContentEditableList.vue
// module id = null
// module chunks = 